import styled from "styled-components";
import { colors, easing, radii } from "../../../theme";

const PADDING = "4px";

export const SwitcherContainer = styled.div`
  position: relative;
  display: inline-grid;
  grid-template-columns: repeat(${({ $count }) => $count}, 1fr);
  padding: ${PADDING};
  border: 1px solid rgba(255, 255, 234, 0.16);
  border-radius: ${radii.pill};
  background-color: rgba(255, 255, 255, 0.07);
`;

export const ActiveIndicator = styled.span`
  position: absolute;
  top: ${PADDING};
  bottom: ${PADDING};
  left: ${PADDING};
  width: calc((100% - 2 * ${PADDING}) / ${({ $count }) => $count});
  border-radius: ${radii.pill};
  background-color: ${colors.primary};
  transform: translateX(${({ $index }) => $index * 100}%);
  transition: transform 0.45s ${easing.out};
`;

export const LanguageOption = styled.button`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  padding: 0.4rem 0.8rem;
  border: none;
  background: none;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: ${({ $active }) =>
    $active ? colors.secondary : "rgba(255, 255, 234, 0.75)"};
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: ${({ $active }) =>
      $active ? colors.secondary : colors.backgroundMain};
  }
`;

export const FlagIcon = styled.span`
  font-size: 0.9rem;
  line-height: 1;
`;

export const LanguageCode = styled.span`
  line-height: 1;
`;
